import { useTranslation } from "react-i18next";
import { IconCopy } from "@tabler/icons-react";
import { LongPressMenu } from "../../ui/LongPressMenu";
import { displayToast } from "../../app/AppToast";

/**
 * What a long press on the user's own message offers: Copy.
 *
 * The app turns text selection off on touch screens (App.css). The answer opts
 * back in (`selectable-text`); the question stays behind this menu, so the long
 * press that opens it does not start a selection instead.
 *
 * @param copyText what Copy puts on the clipboard: the message alone.
 * @param className makes the wrapper hug the message: the menu opens off it.
 */
export function ChatMessageMenu({
  copyText,
  className,
  children,
}: {
  copyText: string;
  className: string;
  children: React.ReactNode;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <LongPressMenu
      className={className}
      items={[
        {
          label: t("Copy"),
          icon: <IconCopy className="size-4 shrink-0" stroke={1.5} />,
          onSelect: () => {
            void navigator.clipboard.writeText(copyText);
            displayToast(t("Copied"), "success");
          },
        },
      ]}
    >
      {children}
    </LongPressMenu>
  );
}
